import { Form, FormInstance, Input, Select } from 'antd';
import { IUserRoles, IWork, IWorkState, IWorker } from 'models';
import { useState } from 'react';
import { userStore } from 'stores';

const options = (arr: IWorker[]) => arr.map(el => ({ value: el.id, label: el.name, key: el.id }));

interface SelectForemanHelpersProps {
	form: FormInstance,
	work?: IWork | null
}

export const SelectForemanHelpers = ({ form, work }: SelectForemanHelpersProps) => {
	const [refWorkers, setRefWorkers] = useState<any>(work?.acf.foreman_info.workers);

	const setWorker = (worker_role: IUserRoles, worker: number) => {
		let newArr = [];
		if (refWorkers) {
			if (worker_role === IUserRoles.FOREMAN) {
				newArr = [...refWorkers.filter((el: any) => el?.worker_role === IUserRoles.HELPER), { worker, worker_role }];
			} else {
				newArr = [...refWorkers, { worker, worker_role }];
			}
		} else {
			newArr = [{ worker, worker_role }];
		}
		setRefWorkers(newArr);
		form.setFieldsValue({
			acf: {
				foreman_info: { workers: newArr },
				state: IWorkState.ASSIGN_WORKERS
			}
		});
	};

	const deleteWorker = (value: number) => {
		form.setFieldsValue({
			fields: { foreman_info: { workers: refWorkers?.filter((el: any) => el.worker !== value) } }
		});
	};

	const foremanRemove = () => {
		let newArr = refWorkers?.filter((el: any) => el.worker_role !== IUserRoles.FOREMAN);

		form.setFieldsValue({
			fields: {
				foreman_info: { workers: newArr },
				state: 'select'
			}
		});
	};

	return (
		<>
			<Form.Item name="foreman" label="Foreman" hidden={!work}>
				<Select
					onSelect={(value) => setWorker(IUserRoles.FOREMAN, value)}
					onClear={foremanRemove}
					options={options(userStore.foremans)}
					allowClear
					disabled={userStore.role !== IUserRoles.ADMIN}
				/>
			</Form.Item>
			<Form.Item name="helpers" label="Helpers" hidden={!work}>
				<Select
					onDeselect={deleteWorker}
					onSelect={(value) => setWorker(IUserRoles.HELPER, value)}
					options={options(userStore.helpersForemans)}
					mode="multiple"
					allowClear
					disabled={userStore.role !== IUserRoles.ADMIN}
				/>
			</Form.Item>

			<Form.List name={['acf', 'foreman_info', 'workers']}>
				{(fields) => fields.map(({ key }) => (
					<div key={key}>
						<Form.Item
							name={[key, 'worker']}
							key={`${key}_worker`}
							hidden
						>
							<Input />
						</Form.Item>
						<Form.Item
							name={[key, 'worker_role']}
							key={`${key}_worker_role`}
							hidden
						>
							<Input />
						</Form.Item>
					</div>
				)
				)}
			</Form.List>
		</>
	);
};